<template>
    <v-container fluid>
        <v-row justify="center">
            <v-col cols="12">
                <responsiveButton :setText="true"
                                  setColor="orange"
                                  setDefaultIcon="mdi-refresh"
                                  setSmallIcon="mdi-refresh"
                                  :setClick="getDataFromServer"
                >
                    Refresh Data
                </responsiveButton>
                <v-divider class="mx-6"></v-divider>
                <v-data-table
                        :headers="mainTableHeader"
                        :items="reportsToSelect"
                        :loading="loading"
                        loading-text="Loading... Please wait"
                        class="elevation-1"
                        :single-expand="true"
                        item-key="id"
                        show-expand
                        @item-expanded="expandedEvent($event)"
                >
                    <!-- Actions -->
                    <template v-slot:item.add="{item}">
                        <v-icon class="mr-4"
                                @click="addNewReport(item)"
                        >
                            mdi-plus
                        </v-icon>
                    </template>
                    <template v-slot:expanded-item="{ headers,item }">
                        <td class="px-0" :colspan="headers.length">
                            <v-row>
                                <v-col cols="11" offset="1">
                                    <data-table
                                            :headers="subTableHeader"
                                            :fetchFunction="()=>getDataInnerFunction"
                                            :tableId="selectedItem.id"
                                            ref="innerTable"
                                    >
                                        <template v-slot:item.status="{item}">
                                            <v-chip class="mr-4"
                                                    :color="DOCUMENT_FILE_STATUS[item.status].color"
                                                    dark>{{ DOCUMENT_FILE_STATUS[item.status].text }}
                                            </v-chip>
                                        </template>
                                        <template v-slot:item.submitted_at="{item}">
                                            {{ item.systemCreatedDateTime | formatDate(DATE_FORMAT.LOCALE_TIME) }}
                                        </template>
                                        <template v-slot:item.download="{item}">
                                            <file-download  :setDisabled="item.documentFile === 'NONE'"
                                                            :name="item.documentFile.name"
                                                            :belong-user-id="path_id"
                                                            :setIcon="true"
                                            >
                                            </file-download>
                                        </template>
                                    </data-table>
                                </v-col>
                            </v-row>
                        </td>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <!--Employee selector modal -->
        <v-dialog v-model="dialog" persistent max-width="500">
            <v-card>
                <v-card-title class="headline">Please select employee to upload</v-card-title>
                <v-card-text>
                    <v-list>
                        <v-list-item-group v-model="employeeSelected" color="indigo">
                            <v-list-item
                                    v-for="(employee, i) in listOfEmployeesForSelector()"
                                    :key="i"
                            >
                                <v-list-item-content>
                                    <v-list-item-title v-text="employee.name"></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </v-card-text>

                <v-card-actions>
                    <v-row no-gutters justify-center>
                        <v-col>
                            <v-btn color="default" text @click.stop="dialog=false">Cancel</v-btn>
                            <v-btn color="primary" @click.stop="uploadReports">Next</v-btn>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    const responsiveButton = ()=> import( '@/components/common/mobile/Button');
    const FileDownload = () => import ( '@/fileHandler/components/FileDownload');
    import {reportSelectorMixin} from "@/shared/mixins/ReportSelectorMixin";
    import alertEventBus from '@/eventBus/AlertEventBus';
    import DataTable from '@/components/common/DataTable';
    import {DOCUMENT_FILE_STATUS} from "@/shared/enums/DocumentFile";

    export default {
        name: "ReportClientUploadTable",
        props:["id", "type"],
        components:{responsiveButton, FileDownload, DataTable},
        mixins:[reportSelectorMixin],
        data(){
            return{
                employeeSelected: [],
                subTableHeader:[
                    {   text: 'Employee Name',
                        value:'employeeName',
                        align: 'left',
                    },
                    {   text: 'Report Status',
                        value:'status',
                        align: 'center',
                    },
                    {   text: 'Submitted At',
                        value:'submitted_at',
                        align: 'center',
                        divider: true
                    },
                    {
                      text: 'Download',
                      value: 'download',
                      align: 'center'
                    }
                ],
            }
        },
        computed:{
            mainTableHeader(){
               return [
                    {
                        text: '',
                        value: 'data-table-expand'
                    },
                    {   text: 'Report Name',
                        value: 'name',
                        align: 'left',
                        divider: true,
                    },
                    {   text: 'Add',
                        value:'add',
                        align: 'center',
                        sortable: false,
                        width: '2%'
                    },
                ];
            },
            DOCUMENT_FILE_STATUS(){
                return DOCUMENT_FILE_STATUS;
            }
        },
        methods:{
            listOfEmployeesForSelector(){
                if(!Object.keys(this.client).length)
                    return [];
                let listEmployees = [];
                for(let id in this.client.employees)
                {
                    listEmployees.push({ id: id, name: this.client.employees[id].name });
                }

                return listEmployees;
            },
            async getDataFromServer()
            {
                this.loading = true;

                try{
                    await this.$store.dispatch('getClient',{id:this.path_id});
                    this.client = this.$store.getters.getClient;

                    if(this.client)
                    {
                        this.getEntityGroupType(this.client.typeID)
                    }else{
                        alertEventBus.setAlert({type:'error', msg: 'Client not found'});
                    }
                }
                catch (e) {
                    //set alert
                    alertEventBus.setAlert({type:'error', msg: e.message});
                }

                this.loading = false;
            },
            addNewReport(item)
            {
                this.reportsSelected = [item.id];
                this.dialog = true;
            },
            uploadReports(){
                let entityId= this.listOfEmployeesForSelector()[this.employeeSelected].id;
                this.$router.push({name: 'clientDetailsReportsAdd', params:{ entity_id: entityId }, query:{redirect:'clientDetailsReports',reports: this.reportsSelected}});
            },
            async getDataInnerFunction(paramsArg){
                let params = {...paramsArg}
                params.clientId=  this.client.id;
                params.reportId= this.selectedItem.id;

                let data = {};
                try {
                    await this.$store.dispatch('getReportTable',params);
                    data.items = this.$store.getters.getReportTable;
                    if(data.items == null){
                        throw  {message: 'Not data available!'};
                    }
                }
                catch (e) {
                    this.$log.debug('Error getting report for clientID {], reportId {}, Error {}', params.clientId,
                    params.reportId, e);
                   throw e;
                }

                if(this.$store.getters.getReportsLastEvaluatedKey != null){
                    data.lastEvaluatedKey = this.$store.getters.getReportsLastEvaluatedKey;
                }

                return data;
            }
        },
        async created(){
            await this.getDataFromServer();
        }
    }
</script>

<style scoped>

</style>